import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";
export interface GetPermissionsResponse {
    items: PermissionDTO[];
}

export interface PermissionDTO {
    id: number;
    label: string;
    description: string;
    type: PermissionType;
}

export enum PermissionType {
    Tenant = "Tenant",
    Mailbox = "Mailbox",
}

export async function GetPermissions(tenantToken: string): Promise<iEmsApiResponseBody<GetPermissionsResponse>> {
    return await CallEmsApi<GetPermissionsResponse>(tenantToken, "GET", "Permissions");
}

export interface GetGlobalRolesResponse {
    items: GlobalRolesListItemDTO[];
}

export interface GlobalRolesListItemDTO {
    id: number;
    name: string;
}

export async function GetGlobalRoles(tenantToken: string): Promise<iEmsApiResponseBody<GetGlobalRolesResponse>> {
    return await CallEmsApi<GetGlobalRolesResponse>(tenantToken, "GET", "GlobalRoles");
}

export interface UserDTO {
    id: number;
    firstName?: string;
    lastName?: string;
}

export interface GetGlobalRoleResponse {
    id?: number;
    name: string;
    permissions: number[];
    updatedAt?: string; // ISO string format for DateTimeOffset
    updatedBy?: UserDTO;
}

export async function GetGlobalRole(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<GetGlobalRoleResponse>> {
    return await CallEmsApi<GetGlobalRoleResponse>(tenantToken, "GET", `GlobalRoles/${id}`);
}

export interface CreateGlobalRoleRequest {
    name: string;
    permissions: number[];
}

export interface CreateGlobalRoleResponse {
    id: number;
}

export async function CreateGlobalRole(
    tenantToken: string,
    request: CreateGlobalRoleRequest,
): Promise<iEmsApiResponseBody<CreateGlobalRoleResponse>> {
    return await CallEmsApi<CreateGlobalRoleResponse>(tenantToken, "POST", "GlobalRoles", request);
}

export interface UpdateGlobalRoleRequest {
    name: string;
    permissions: number[];
}

export async function UpdateGlobalRole(
    tenantToken: string,
    id: number,
    request: UpdateGlobalRoleRequest,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `GlobalRoles/${id}`, request);
}

export async function DeleteGlobalRole(tenantToken: string, id: number): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `GlobalRoles/${id}`);
}

export interface GetMailboxRolesResponse {
    items: MailboxRolesListItemDTO[];
}

export interface MailboxRolesListItemDTO {
    id: number;
    name: string;
}

export async function GetMailboxRoles(tenantToken: string): Promise<iEmsApiResponseBody<GetMailboxRolesResponse>> {
    return await CallEmsApi<GetMailboxRolesResponse>(tenantToken, "GET", "MailboxRoles");
}

export interface GetMailboxRoleResponse {
    id: number;
    name: string;
    permissions: number[];
    updatedAt?: string; // ISO string format for DateTimeOffset
    updatedBy?: UserDTO;
}

export async function GetMailboxRole(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<GetMailboxRoleResponse>> {
    return await CallEmsApi<GetMailboxRoleResponse>(tenantToken, "GET", `MailboxRoles/${id}`);
}

export interface CreateMailboxRoleRequest {
    name: string;
    permissions: number[];
}

export interface CreateMailboxRoleResponse {
    id: number;
}

export async function CreateMailboxRole(
    tenantToken: string,
    request: CreateMailboxRoleRequest,
): Promise<iEmsApiResponseBody<CreateMailboxRoleResponse>> {
    return await CallEmsApi<CreateMailboxRoleResponse>(tenantToken, "POST", "MailboxRoles", request);
}

export interface UpdateMailboxRoleRequest {
    name: string;
    permissions: number[];
}

export async function UpdateMailboxRole(
    tenantToken: string,
    id: number,
    request: UpdateMailboxRoleRequest,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `MailboxRoles/${id}`, request);
}

export async function DeleteMailboxRole(tenantToken: string, id: number): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `MailboxRoles/${id}`);
}
